export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/online-form-response.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/onlineFormResponse.js